// import React, { useMemo, useState } from "react";
// import ConfirmationPopup from "../../../../components/common/ConfirmationPopup";
// import { useModalWithUrl } from "../../../../hooks/useModalWithUrl";
// import DrawerUsageGuide from "./DrawerUsageGuide";
// import AccordionUserGuide from "./AccordionUserGuide";
// import ActionMenu from "../../../../components/elements/ActionMenu";
// import { toast } from "react-toastify";
// import ModalUserGuide from "./ModalUserGuide";
// import Tabs from "../../../../components/elements/Tabs";
// import { useTabQuery } from "../../../../hooks/useTabQuery";
// import NotFoundPage from "../../../../components/common/NotFoundPage";
// import SelectUpdate from "../../../../components/form/select/SelectUpdate";
// import FlexibleSelect from "../../../../components/form/select/FlexibleSelect";
// const Dashboard = () => {
//   const { isOpen, openModal, closeModal } = useModalWithUrl(
//     "confirmation",
//     "open"
//   );
//   const [loading, setLoading] = useState(false);
//   const [multiValue, setMultiValue] = useState([]);
//   const [singleValue, setSingleValue] = useState(null);

//   const options = [
//     { name: "5 Items", value: 5 },
//     { name: "10 Items", value: 10 },
//     { name: "20 Items", value: 20 },
//     { name: "30 Items", value: 30 },
//     { name: "50 Items", value: 50 },
//     { name: "100 Items", value: 100 },
//   ];

//   const allOptions = [{ name: "All Items", value: 1000 }, ...options];

//   const [selectedFlag, setSelectedFlag] = useState(null);
//   const [selectedUser, setSelectedUser] = useState(null);

//   const flagOptions = [
//     // UEFA (Europe)
//     { name: "Albania", value: "al", image: "https://flagcdn.com/al.svg" },
//     { name: "Andorra", value: "ad", image: "https://flagcdn.com/ad.svg" },
//     { name: "Armenia", value: "am", image: "https://flagcdn.com/am.svg" },
//     { name: "Austria", value: "at", image: "https://flagcdn.com/at.svg" },
//     { name: "Azerbaijan", value: "az", image: "https://flagcdn.com/az.svg" },
//     { name: "Belarus", value: "by", image: "https://flagcdn.com/by.svg" },
//     { name: "Belgium", value: "be", image: "https://flagcdn.com/be.svg" },
//     {
//       name: "Bosnia and Herzegovina",
//       value: "ba",
//       image: "https://flagcdn.com/ba.svg",
//     },
//     { name: "Bulgaria", value: "bg", image: "https://flagcdn.com/bg.svg" },
//     { name: "Croatia", value: "hr", image: "https://flagcdn.com/hr.svg" },
//     { name: "Cyprus", value: "cy", image: "https://flagcdn.com/cy.svg" },
//     {
//       name: "Czech Republic",
//       value: "cz",
//       image: "https://flagcdn.com/cz.svg",
//     },
//     { name: "Denmark", value: "dk", image: "https://flagcdn.com/dk.svg" },
//     {
//       name: "England",
//       value: "gb-eng",
//       image: "https://flagcdn.com/gb-eng.svg",
//     },
//     { name: "Estonia", value: "ee", image: "https://flagcdn.com/ee.svg" },
//     { name: "Faroe Islands", value: "fo", image: "https://flagcdn.com/fo.svg" },
//     { name: "Finland", value: "fi", image: "https://flagcdn.com/fi.svg" },
//     { name: "France", value: "fr", image: "https://flagcdn.com/fr.svg" },
//     { name: "Georgia", value: "ge", image: "https://flagcdn.com/ge.svg" },
//     { name: "Germany", value: "de", image: "https://flagcdn.com/de.svg" },
//     { name: "Gibraltar", value: "gi", image: "https://flagcdn.com/gi.svg" },
//     { name: "Greece", value: "gr", image: "https://flagcdn.com/gr.svg" },
//     { name: "Hungary", value: "hu", image: "https://flagcdn.com/hu.svg" },
//     { name: "Iceland", value: "is", image: "https://flagcdn.com/is.svg" },
//     { name: "Ireland", value: "ie", image: "https://flagcdn.com/ie.svg" },
//     { name: "Israel", value: "il", image: "https://flagcdn.com/il.svg" },
//     { name: "Italy", value: "it", image: "https://flagcdn.com/it.svg" },
//     { name: "Kazakhstan", value: "kz", image: "https://flagcdn.com/kz.svg" },
//     { name: "Kosovo", value: "xk", image: "https://flagcdn.com/xk.svg" },
//     { name: "Latvia", value: "lv", image: "https://flagcdn.com/lv.svg" },
//     { name: "Liechtenstein", value: "li", image: "https://flagcdn.com/li.svg" },
//     { name: "Lithuania", value: "lt", image: "https://flagcdn.com/lt.svg" },
//     { name: "Luxembourg", value: "lu", image: "https://flagcdn.com/lu.svg" },
//     { name: "Malta", value: "mt", image: "https://flagcdn.com/mt.svg" },
//     { name: "Moldova", value: "md", image: "https://flagcdn.com/md.svg" },
//     { name: "Monaco", value: "mc", image: "https://flagcdn.com/mc.svg" },
//     { name: "Montenegro", value: "me", image: "https://flagcdn.com/me.svg" },
//     { name: "Netherlands", value: "nl", image: "https://flagcdn.com/nl.svg" },
//     {
//       name: "North Macedonia",
//       value: "mk",
//       image: "https://flagcdn.com/mk.svg",
//     },
//     {
//       name: "Northern Ireland",
//       value: "gb-nir",
//       image: "https://flagcdn.com/gb-nir.svg",
//     },
//     { name: "Norway", value: "no", image: "https://flagcdn.com/no.svg" },
//     { name: "Poland", value: "pl", image: "https://flagcdn.com/pl.svg" },
//     { name: "Portugal", value: "pt", image: "https://flagcdn.com/pt.svg" },
//     { name: "Romania", value: "ro", image: "https://flagcdn.com/ro.svg" },
//     { name: "Russia", value: "ru", image: "https://flagcdn.com/ru.svg" },
//     { name: "San Marino", value: "sm", image: "https://flagcdn.com/sm.svg" },
//     {
//       name: "Scotland",
//       value: "gb-sct",
//       image: "https://flagcdn.com/gb-sct.svg",
//     },
//     { name: "Serbia", value: "rs", image: "https://flagcdn.com/rs.svg" },
//     { name: "Slovakia", value: "sk", image: "https://flagcdn.com/sk.svg" },
//     { name: "Slovenia", value: "si", image: "https://flagcdn.com/si.svg" },
//     { name: "Spain", value: "es", image: "https://flagcdn.com/es.svg" },
//     { name: "Sweden", value: "se", image: "https://flagcdn.com/se.svg" },
//     { name: "Switzerland", value: "ch", image: "https://flagcdn.com/ch.svg" },
//     { name: "Turkey", value: "tr", image: "https://flagcdn.com/tr.svg" },
//     { name: "Ukraine", value: "ua", image: "https://flagcdn.com/ua.svg" },
//     { name: "Wales", value: "gb-wls", image: "https://flagcdn.com/gb-wls.svg" },

//     // CONMEBOL (South America)
//     { name: "Argentina", value: "ar", image: "https://flagcdn.com/ar.svg" },
//     { name: "Bolivia", value: "bo", image: "https://flagcdn.com/bo.svg" },
//     { name: "Brazil", value: "br", image: "https://flagcdn.com/br.svg" },
//     { name: "Chile", value: "cl", image: "https://flagcdn.com/cl.svg" },
//     { name: "Colombia", value: "co", image: "https://flagcdn.com/co.svg" },
//     { name: "Ecuador", value: "ec", image: "https://flagcdn.com/ec.svg" },
//     { name: "Paraguay", value: "py", image: "https://flagcdn.com/py.svg" },
//     { name: "Peru", value: "pe", image: "https://flagcdn.com/pe.svg" },
//     { name: "Uruguay", value: "uy", image: "https://flagcdn.com/uy.svg" },
//     { name: "Venezuela", value: "ve", image: "https://flagcdn.com/ve.svg" },

//     // CONCACAF (North & Central America, Caribbean)
//     {
//       name: "Antigua and Barbuda",
//       value: "ag",
//       image: "https://flagcdn.com/ag.svg",
//     },
//     { name: "Bahamas", value: "bs", image: "https://flagcdn.com/bs.svg" },
//     { name: "Barbados", value: "bb", image: "https://flagcdn.com/bb.svg" },
//     { name: "Belize", value: "bz", image: "https://flagcdn.com/bz.svg" },
//     { name: "Bermuda", value: "bm", image: "https://flagcdn.com/bm.svg" },
//     { name: "Canada", value: "ca", image: "https://flagcdn.com/ca.svg" },
//     { name: "Costa Rica", value: "cr", image: "https://flagcdn.com/cr.svg" },
//     { name: "Cuba", value: "cu", image: "https://flagcdn.com/cu.svg" },
//     { name: "Dominica", value: "dm", image: "https://flagcdn.com/dm.svg" },
//     {
//       name: "Dominican Republic",
//       value: "do",
//       image: "https://flagcdn.com/do.svg",
//     },
//     { name: "El Salvador", value: "sv", image: "https://flagcdn.com/sv.svg" },
//     { name: "Grenada", value: "gd", image: "https://flagcdn.com/gd.svg" },
//     { name: "Guatemala", value: "gt", image: "https://flagcdn.com/gt.svg" },
//     { name: "Haiti", value: "ht", image: "https://flagcdn.com/ht.svg" },
//     { name: "Honduras", value: "hn", image: "https://flagcdn.com/hn.svg" },
//     { name: "Jamaica", value: "jm", image: "https://flagcdn.com/jm.svg" },
//     { name: "Mexico", value: "mx", image: "https://flagcdn.com/mx.svg" },
//     { name: "Nicaragua", value: "ni", image: "https://flagcdn.com/ni.svg" },
//     { name: "Panama", value: "pa", image: "https://flagcdn.com/pa.svg" },
//     {
//       name: "Saint Kitts and Nevis",
//       value: "kn",
//       image: "https://flagcdn.com/kn.svg",
//     },
//     { name: "Saint Lucia", value: "lc", image: "https://flagcdn.com/lc.svg" },
//     {
//       name: "Saint Vincent and the Grenadines",
//       value: "vc",
//       image: "https://flagcdn.com/vc.svg",
//     },
//     {
//       name: "Trinidad and Tobago",
//       value: "tt",
//       image: "https://flagcdn.com/tt.svg",
//     },
//     { name: "United States", value: "us", image: "https://flagcdn.com/us.svg" },

//     // AFC (Asia)
//     { name: "Afghanistan", value: "af", image: "https://flagcdn.com/af.svg" },
//     { name: "Australia", value: "au", image: "https://flagcdn.com/au.svg" },
//     { name: "Bahrain", value: "bh", image: "https://flagcdn.com/bh.svg" },
//     { name: "Bangladesh", value: "bd", image: "https://flagcdn.com/bd.svg" },
//     { name: "Bhutan", value: "bt", image: "https://flagcdn.com/bt.svg" },
//     { name: "Brunei", value: "bn", image: "https://flagcdn.com/bn.svg" },
//     { name: "Cambodia", value: "kh", image: "https://flagcdn.com/kh.svg" },
//     { name: "China", value: "cn", image: "https://flagcdn.com/cn.svg" },
//     {
//       name: "Chinese Taipei",
//       value: "tw",
//       image: "https://flagcdn.com/tw.svg",
//     },
//     { name: "Guam", value: "gu", image: "https://flagcdn.com/gu.svg" },
//     { name: "Hong Kong", value: "hk", image: "https://flagcdn.com/hk.svg" },
//     { name: "India", value: "in", image: "https://flagcdn.com/in.svg" },
//     { name: "Indonesia", value: "id", image: "https://flagcdn.com/id.svg" },
//     { name: "Iran", value: "ir", image: "https://flagcdn.com/ir.svg" },
//     { name: "Iraq", value: "iq", image: "https://flagcdn.com/iq.svg" },
//     { name: "Japan", value: "jp", image: "https://flagcdn.com/jp.svg" },
//     { name: "Jordan", value: "jo", image: "https://flagcdn.com/jo.svg" },
//     { name: "Kuwait", value: "kw", image: "https://flagcdn.com/kw.svg" },
//     { name: "Kyrgyzstan", value: "kg", image: "https://flagcdn.com/kg.svg" },
//     { name: "Laos", value: "la", image: "https://flagcdn.com/la.svg" },
//     { name: "Lebanon", value: "lb", image: "https://flagcdn.com/lb.svg" },
//     { name: "Macau", value: "mo", image: "https://flagcdn.com/mo.svg" },
//     { name: "Malaysia", value: "my", image: "https://flagcdn.com/my.svg" },
//     { name: "Maldives", value: "mv", image: "https://flagcdn.com/mv.svg" },
//     { name: "Mongolia", value: "mn", image: "https://flagcdn.com/mn.svg" },
//     { name: "Myanmar", value: "mm", image: "https://flagcdn.com/mm.svg" },
//     { name: "Nepal", value: "np", image: "https://flagcdn.com/np.svg" },
//     { name: "North Korea", value: "kp", image: "https://flagcdn.com/kp.svg" },
//     { name: "Oman", value: "om", image: "https://flagcdn.com/om.svg" },
//     { name: "Pakistan", value: "pk", image: "https://flagcdn.com/pk.svg" },
//     { name: "Palestine", value: "ps", image: "https://flagcdn.com/ps.svg" },
//     { name: "Philippines", value: "ph", image: "https://flagcdn.com/ph.svg" },
//     { name: "Qatar", value: "qa", image: "https://flagcdn.com/qa.svg" },
//     { name: "Saudi Arabia", value: "sa", image: "https://flagcdn.com/sa.svg" },
//     { name: "Singapore", value: "sg", image: "https://flagcdn.com/sg.svg" },
//     { name: "South Korea", value: "kr", image: "https://flagcdn.com/kr.svg" },
//     { name: "Sri Lanka", value: "lk", image: "https://flagcdn.com/lk.svg" },
//     { name: "Syria", value: "sy", image: "https://flagcdn.com/sy.svg" },
//     { name: "Tajikistan", value: "tj", image: "https://flagcdn.com/tj.svg" },
//     { name: "Thailand", value: "th", image: "https://flagcdn.com/th.svg" },
//     { name: "Timor-Leste", value: "tl", image: "https://flagcdn.com/tl.svg" },
//     { name: "Turkmenistan", value: "tm", image: "https://flagcdn.com/tm.svg" },
//     {
//       name: "United Arab Emirates",
//       value: "ae",
//       image: "https://flagcdn.com/ae.svg",
//     },
//     { name: "Uzbekistan", value: "uz", image: "https://flagcdn.com/uz.svg" },
//     { name: "Vietnam", value: "vn", image: "https://flagcdn.com/vn.svg" },
//     { name: "Yemen", value: "ye", image: "https://flagcdn.com/ye.svg" },

//     // CAF (Africa)
//     { name: "Algeria", value: "dz", image: "https://flagcdn.com/dz.svg" },
//     { name: "Angola", value: "ao", image: "https://flagcdn.com/ao.svg" },
//     { name: "Benin", value: "bj", image: "https://flagcdn.com/bj.svg" },
//     { name: "Botswana", value: "bw", image: "https://flagcdn.com/bw.svg" },
//     { name: "Burkina Faso", value: "bf", image: "https://flagcdn.com/bf.svg" },
//     { name: "Burundi", value: "bi", image: "https://flagcdn.com/bi.svg" },
//     { name: "Cameroon", value: "cm", image: "https://flagcdn.com/cm.svg" },
//     { name: "Cape Verde", value: "cv", image: "https://flagcdn.com/cv.svg" },
//     {
//       name: "Central African Republic",
//       value: "cf",
//       image: "https://flagcdn.com/cf.svg",
//     },
//     { name: "Chad", value: "td", image: "https://flagcdn.com/td.svg" },
//     { name: "Comoros", value: "km", image: "https://flagcdn.com/km.svg" },
//     { name: "Congo", value: "cg", image: "https://flagcdn.com/cg.svg" },
//     { name: "DR Congo", value: "cd", image: "https://flagcdn.com/cd.svg" },
//     { name: "Djibouti", value: "dj", image: "https://flagcdn.com/dj.svg" },
//     { name: "Egypt", value: "eg", image: "https://flagcdn.com/eg.svg" },
//     {
//       name: "Equatorial Guinea",
//       value: "gq",
//       image: "https://flagcdn.com/gq.svg",
//     },
//     { name: "Eritrea", value: "er", image: "https://flagcdn.com/er.svg" },
//     { name: "Eswatini", value: "sz", image: "https://flagcdn.com/sz.svg" },
//     { name: "Ethiopia", value: "et", image: "https://flagcdn.com/et.svg" },
//     { name: "Gabon", value: "ga", image: "https://flagcdn.com/ga.svg" },
//     { name: "Gambia", value: "gm", image: "https://flagcdn.com/gm.svg" },
//     { name: "Ghana", value: "gh", image: "https://flagcdn.com/gh.svg" },
//     { name: "Guinea", value: "gn", image: "https://flagcdn.com/gn.svg" },
//     { name: "Guinea-Bissau", value: "gw", image: "https://flagcdn.com/gw.svg" },
//     { name: "Ivory Coast", value: "ci", image: "https://flagcdn.com/ci.svg" },
//     { name: "Kenya", value: "ke", image: "https://flagcdn.com/ke.svg" },
//     { name: "Lesotho", value: "ls", image: "https://flagcdn.com/ls.svg" },
//     { name: "Liberia", value: "lr", image: "https://flagcdn.com/lr.svg" },
//     { name: "Libya", value: "ly", image: "https://flagcdn.com/ly.svg" },
//     { name: "Madagascar", value: "mg", image: "https://flagcdn.com/mg.svg" },
//     { name: "Malawi", value: "mw", image: "https://flagcdn.com/mw.svg" },
//     { name: "Mali", value: "ml", image: "https://flagcdn.com/ml.svg" },
//     { name: "Mauritania", value: "mr", image: "https://flagcdn.com/mr.svg" },
//     { name: "Mauritius", value: "mu", image: "https://flagcdn.com/mu.svg" },
//     { name: "Morocco", value: "ma", image: "https://flagcdn.com/ma.svg" },
//     { name: "Mozambique", value: "mz", image: "https://flagcdn.com/mz.svg" },
//     { name: "Namibia", value: "na", image: "https://flagcdn.com/na.svg" },
//     { name: "Niger", value: "ne", image: "https://flagcdn.com/ne.svg" },
//     { name: "Nigeria", value: "ng", image: "https://flagcdn.com/ng.svg" },
//     { name: "Rwanda", value: "rw", image: "https://flagcdn.com/rw.svg" },
//     {
//       name: "São Tomé and Príncipe",
//       value: "st",
//       image: "https://flagcdn.com/st.svg",
//     },
//     { name: "Senegal", value: "sn", image: "https://flagcdn.com/sn.svg" },
//     { name: "Seychelles", value: "sc", image: "https://flagcdn.com/sc.svg" },
//     { name: "Sierra Leone", value: "sl", image: "https://flagcdn.com/sl.svg" },
//     { name: "Somalia", value: "so", image: "https://flagcdn.com/so.svg" },
//     { name: "South Africa", value: "za", image: "https://flagcdn.com/za.svg" },
//     { name: "South Sudan", value: "ss", image: "https://flagcdn.com/ss.svg" },
//     { name: "Sudan", value: "sd", image: "https://flagcdn.com/sd.svg" },
//     { name: "Tanzania", value: "tz", image: "https://flagcdn.com/tz.svg" },
//     { name: "Togo", value: "tg", image: "https://flagcdn.com/tg.svg" },
//     { name: "Tunisia", value: "tn", image: "https://flagcdn.com/tn.svg" },
//     { name: "Uganda", value: "ug", image: "https://flagcdn.com/ug.svg" },
//     { name: "Zambia", value: "zm", image: "https://flagcdn.com/zm.svg" },
//     { name: "Zimbabwe", value: "zw", image: "https://flagcdn.com/zw.svg" },

//     // OFC (Oceania)
//     { name: "Cook Islands", value: "ck", image: "https://flagcdn.com/ck.svg" },
//     { name: "Fiji", value: "fj", image: "https://flagcdn.com/fj.svg" },
//     { name: "New Caledonia", value: "nc", image: "https://flagcdn.com/nc.svg" },
//     { name: "New Zealand", value: "nz", image: "https://flagcdn.com/nz.svg" },
//     {
//       name: "Papua New Guinea",
//       value: "pg",
//       image: "https://flagcdn.com/pg.svg",
//     },
//     { name: "Samoa", value: "ws", image: "https://flagcdn.com/ws.svg" },
//     {
//       name: "Solomon Islands",
//       value: "sb",
//       image: "https://flagcdn.com/sb.svg",
//     },
//     { name: "Tahiti", value: "pf", image: "https://flagcdn.com/pf.svg" },
//     { name: "Tonga", value: "to", image: "https://flagcdn.com/to.svg" },
//     { name: "Vanuatu", value: "vu", image: "https://flagcdn.com/vu.svg" },
//   ];

//   const userOptions = [
//     {
//       name: "John Doe",
//       value: "john",
//       image: "https://i.pravatar.cc/40?img=1",
//     },
//     {
//       name: "Jane Smith",
//       value: "jane",
//       image: "https://i.pravatar.cc/40?img=2",
//     },
//     {
//       name: "Alice Brown",
//       value: "alice",
//       image: "https://i.pravatar.cc/40?img=3",
//     },
//   ];

//   const handleAction = (actionData) => {
//     console.log(actionData, "actionDataactionData");
//     if (actionData.button_type === "confirm") {
//       setLoading(true);
//       // Perform your action here
//       setTimeout(() => {
//         setLoading(false);
//         closeModal();
//         console.log("Action confirmed!");
//       }, 2000);
//     } else if (actionData.button_type === "close") {
//       closeModal();
//       console.log("Modal closed");
//     }
//   };

//   const menuItems = [
//     {
//       name: "View",
//       icon: "fa-regular fa-eye",
//       link: "/view/123",
//     },
//     {
//       name: "Edit",
//       icon: "fa-regular fa-pen-to-square",
//       link: "/edit/123",
//     },
//     {
//       name: "Delete",
//       icon: "fa-regular fa-trash-can",
//       onClick: () => toast.success("Deleted item"),
//       standout: true,
//     },
//   ];

//   const tabs = useMemo(
//     () => [
//       {
//         label: "User List",
//         icon: "fa-light fa-user",
//         content: "<List />",
//         key: "user-list",
//       },
//       {
//         label: "Custom Attributes",
//         icon: "fa-light fa-gear",
//         type: "image",
//         content: "<CustomAttributes />",
//         key: "custom-attributes",
//       },
//       {
//         label: "Privacy & Security",
//         icon: "fa-light fa-fingerprint",
//         type: "image",
//         content: "<PrivacyAndSecurity />",
//         key: "privacy-security",
//       },
//       {
//         label: "Bulk Import",
//         icon: "fa-light fa-file-import",
//         type: "image",
//         content: "<BulkUploadUser />",
//         key: "bulk-import",
//       },
//     ],
//     []
//   );

//   const { selectedIndex, handleTabChange, validTab } = useTabQuery(tabs);

//   if (!validTab) {
//     return <NotFoundPage link="/admin/users?tab=user-list" />;
//   }

//   return (
//     <div>
//       <div>
//         <section className="max-w-3xl mx-auto p-6">
//           <h2 className="text-2xl font-bold mb-4">
//             Confirmation Modal Example
//           </h2>
//           <button
//             onClick={openModal}
//             className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
//           >
//             Confirmation Modal
//           </button>
//           <div className="flex flex-col items-center justify-center  bg-gray-50 p-6 gap-10">
//             <div className="text-2xl font-semibold">
//               SelectUpdate Component Demo
//             </div>
//             <div className="flex flex-col gap-8 p-2 max-w-md mx-auto">
//               {/* Flag Dropdown */}
//               <div>
//                 <h2 className="text-lg font-semibold mb-2">Select a Country</h2>
//                 <div className="w-80">
//                   <FlexibleSelect
//                     dropdownData={flagOptions}
//                     selectedValue={selectedFlag}
//                     onChange={setSelectedFlag}
//                     displayKey="name"
//                     valueKey="value"
//                     imageKey="image"
//                     placeholder="Choose a country"
//                     label="Country"
//                     isSearch
//                   />
//                 </div>
//               </div>

//               {/* User Dropdown */}
//               <div>
//                 <h2 className="text-lg font-semibold mb-2">Select a User</h2>
//                 <div className="w-80">
//                   <FlexibleSelect
//                     dropdownData={userOptions}
//                     selectedValue={selectedUser}
//                     onChange={setSelectedUser}
//                     displayKey="name"
//                     valueKey="value"
//                     imageKey="image"
//                     placeholder="Choose a user"
//                     label="User"
//                     isSearch
//                   />
//                 </div>
//               </div>
//             </div>

//             <div className="flex items-start justify-center gap-10 flex-wrap">
//               {/* Multi Select Example */}
//               <div className="w-80">
//                 <FlexibleSelect
//                   dropdownData={allOptions}
//                   selectedValue={multiValue}
//                   onChange={setMultiValue}
//                   type="multiple"
//                   isSearch={true}
//                   placeholder="Select multiple items"
//                   label="Multi Select"
//                   labelClasses="font-semibold text-gray-800"
//                   required={true}
//                   // errorText={multiValue.length === 0 ? "Please select at least one" : ""}
//                 />
//               </div>

//               {/* Single Select Example */}
//               <div className="w-80">
//                 <FlexibleSelect
//                   dropdownData={options}
//                   selectedValue={singleValue}
//                   onChange={setSingleValue}
//                   type="single"
//                   isSearch={true}
//                   placeholder="Select one item"
//                   label="Single Select"
//                   labelClasses="font-semibold text-gray-800"
//                   required={true}
//                   placement="top"
//                   // errorText={!singleValue ? "Please select a value" : ""}
//                 />
//               </div>
//             </div>
//           </div>
//         </section>
//         <section className="max-w-3xl mx-auto p-6">
//           <h2 className="text-2xl font-bold mb-4">Action Menu Example</h2>
//           <ActionMenu data={menuItems} xPlacement="right-0" />
//         </section>
//         <section className="max-w-3xl mx-auto p-6">
//           <h2 className="text-2xl font-bold mb-4">Modal View Example</h2>
//           <ModalUserGuide />
//         </section>
//         <section className="max-w-3xl mx-auto p-6">
//           <h2 className="text-2xl font-bold mb-4">Tabs Example</h2>
//           <Tabs
//             items={tabs}
//             selectedIndex={selectedIndex}
//             setSelectedIndex={handleTabChange}
//           />
//         </section>

//         <AccordionUserGuide />
//         <DrawerUsageGuide />

//         <ConfirmationPopup
//           isOpen={isOpen}
//           setIsOpen={closeModal}
//           getActionValue={handleAction}
//           title="Confirm Action"
//           message="Are you sure you want to proceed?"
//           confirmButtonLabel="Yes, Proceed"
//           cancelButtonLabel="Cancel"
//           loading={loading}
//           setLoading={setLoading}
//         />
//       </div>
//     </div>
//   );
// };

// export default Dashboard;
import React from "react";

function index() {
  return <div>index</div>;
}

export default index;
